import { useTranslation } from 'react-i18next';

import DefaultLayout from '@/layouts/default.tsx';
import Container from '@/components/Container/Container.tsx';
import { useSongbooks } from '@/hooks/useSongbook.ts';
import Spinner from '@/components/Spinner/Spinner.tsx';

import ExportButton from '../components/ExportButton.tsx';
import ImportButton from '../components/ImportButton.tsx';

import SongbookList from './SongbookList.tsx';

function SongbookHome() {
  const { t } = useTranslation();
  const { isLoading } = useSongbooks();

  return (
    <DefaultLayout>
      <div className="bg-content2">
        <Container>
          <div className="h-20 flex justify-between items-center">
            <h1 className="text-3xl">{t('songbook.home.title')}</h1>
            {!isLoading && (
              <div className="flex gap-2">
                <ExportButton />
                <ImportButton />
              </div>
            )}
          </div>
        </Container>
      </div>
      <Container className="flex grow flex-col gap-8 py-8">
        {isLoading && (
          <div className="opacity-0 animate-fade-in [animation-delay:1000ms] text-default-600 justify-center items-center flex w-full grow">
            <Spinner />
          </div>
        )}
        <SongbookList />
      </Container>
    </DefaultLayout>
  );
}

export default SongbookHome;
